/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import { IKeyValue } from "../../store/api/devices/types";

export const TASK = {
  REBOOT: {
    NAME: "Reboot",
    VALUE: "RebootServicesNode",
  },
  NRCELLENABLE: {
    NAME: "Enable Cell",
    VALUE: "NRCellEnable",
  },
  NRCELLDISABLE: {
    NAME: "Disable Cell",
    VALUE: "NRCellDisable",
  },
  LTECELLENABLE: {
    NAME: "Enable Cell",
    VALUE: "LTECellEnable",
  },
  LTECELLDISABLE: {
    NAME: "Disable Cell",
    VALUE: "LTECellDisable",
  },
  RADIONODEENABLE: {
    NAME: "Enable RadioNode",
    VALUE: "RadioNodeEnable",
  },
  RADIONODEDISABLE: {
    NAME: "Disable RadioNode",
    VALUE: "RadioNodeDisable",
  },
  REBOOTRADIONODE: {
    NAME: "Reboot RadioNode",
    VALUE: "RebootRadioNode",
  },
  DUENABLE: {
    NAME: "Enable DU",
    VALUE: "DuEnable",
  },
  DUDISABLE: {
    NAME: "Disable DU",
    VALUE: "DuDisable",
  },
};

export interface Action {
  title: string;
  component?: React.ReactNode;
  isComponentRequired: boolean;
  isTask: boolean;
  name: string;
  taskName?: string;
  deviceKey?: string;
  selectedData?: IKeyValue;
  dialogue?: string;
  actionName?: string;
}
